/**
 * 迁移 v4: 为写作卡片补充 cnTranslation 字段
 */

import type { Transaction } from 'dexie';
import { registerMigration } from './registry';
import { defaultDb } from '../indexedDb';

// 从 JSON 加载翻译映射（运行时加载）
let translationMap: Map<string, string> | null = null;

async function loadTranslationMap(): Promise<Map<string, string>> {
  if (translationMap) return translationMap;
  
  try {
    const resp = await fetch('/ielts_data/writing/writingSeedCards.json');
    const cards = await resp.json();
    translationMap = new Map();
    
    for (const card of cards) {
      const cnTranslation = card.writingExtra?.cnTranslation;
      if (card.id && cnTranslation) {
        translationMap.set(card.id, cnTranslation);
      }
    }
    
    console.log(`[cnTranslation] Loaded ${translationMap.size} translations from JSON`);
    return translationMap;
  } catch (err) {
    console.error('[cnTranslation] Failed to load translations:', err);
    return new Map();
  }
}

/**
 * 为缺少 cnTranslation 的写作卡片填充翻译
 * 可以在导入后或任何时候调用
 */
export async function fillMissingCnTranslations(): Promise<number> {
  const map = await loadTranslationMap();
  if (map.size === 0) {
    console.warn('[cnTranslation] No translations loaded, skipping');
    return 0;
  }
  
  const writingCards = await defaultDb.cards.where('type').equals('writing').toArray();
  
  let updated = 0;
  for (const card of writingCards) {
    const translation = map.get(card.id);
    if (translation && !card.writingMeta?.cnTranslation) {
      await defaultDb.cards.update(card.id, {
        writingMeta: {
          ...(card.writingMeta ?? {}),
          cnTranslation: translation,
        },
      });
      updated++;
    }
  }
  
  console.log(`[cnTranslation] Filled ${updated}/${writingCards.length} writing cards`);
  return updated;
}

registerMigration({
  version: 4,
  name: 'addCnTranslation',
  description: '为写作卡片补充中文翻译字段',
  
  async up(tx: Transaction) {
    const map = await loadTranslationMap();
    if (map.size === 0) {
      console.warn('[v4 migration] No translations loaded, skipping');
      return;
    }
    
    const cards = tx.table('cards');
    const writingCards = await cards.where('type').equals('writing').toArray();
    
    let updated = 0;
    for (const card of writingCards) {
      const translation = map.get(card.id);
      if (translation && !card.writingMeta?.cnTranslation) {
        await cards.update(card.id, {
          writingMeta: {
            ...(card.writingMeta ?? {}),
            cnTranslation: translation,
          },
        });
        updated++;
      }
    }
    
    console.log(`[v4 migration] Updated ${updated}/${writingCards.length} writing cards with cnTranslation`);
  },
});
